import { useContext } from 'react';
import { usePagination, useWP } from '../../../hooks/WPHooks';
import { SearchHookReturn } from './SearchHook';
import { AppContext } from '../../../state/AppContextProvider';
import { WP_FetchPage } from '../../../services/WPService';
import { SearchCategoryParams, SearchPostType } from '../../../model/models';

export const useSearchPosts: (
  resultFilter?: (it: SearchPostType) => boolean
) => SearchHookReturn = (resultFilter) => {
  const { wp } = useWP();

  const { state } = useContext(AppContext);

  const fetch: WP_FetchPage<SearchPostType> = (
    pagination,
    { keywords, category }
  ) => {
    const searchParams = SearchCategoryParams[category];
    return wp.search<SearchPostType>(
      pagination,
      state.locale,
      searchParams,
      keywords,
      resultFilter
    );
  };

  const {
    items,
    fetchMore,
    hasMoreItems,
    loading,
    reset,
    isReset,
    page,
    totalPage,
  } = usePagination(fetch);

  return {
    reset: reset,
    isReset: isReset,
    loading: loading,
    hasMore: hasMoreItems,
    search: fetchMore,
    page: page,
    totalPage: totalPage,
    items,
  };
};
